

import subscriptionService from './subscriptionService' 
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    subInfo: {},
   
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,

}

//Functions to handle async actions for the subscription slice.

//get subscription information from a user
export const getSubscription = createAsyncThunk('subscription/get', 
    async( _, thunkAPI) =>{
        //thunkAPI to connect to backEnd 
        try {
            const token = thunkAPI.getState().auth.user.token
            return await subscriptionService.getSubscription(token)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
        
        return thunkAPI.rejectWithValue(message)
        }
})


//action to start a monthly subscription basic tier
export const startBasicSub = createAsyncThunk('subscription/startBasic', 
    async( _, thunkAPI) =>{
        //thunkAPI to connect to backEnd 
        try {
            const token = thunkAPI.getState().auth.user.token
            return await subscriptionService.startBasicMonthly(token)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
        
        return thunkAPI.rejectWithValue(message)
        }
})





//action to start a pro monthly subscription
export const startProSub = createAsyncThunk('subscription/startPro', 
    async( _, thunkAPI) =>{
        //thunkAPI to connect to backEnd 
        try {
            const token = thunkAPI.getState().auth.user.token
            return await subscriptionService.startProMonthly(token)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
        
        return thunkAPI.rejectWithValue(message)
        }
})



//action to cancel a subscription 
export const cancelSub = createAsyncThunk('subscription/cancel',
    async( _, thunkAPI) =>{
        //thunkAPI to connect to backEnd 
        try {
            const token = thunkAPI.getState().auth.user.token
            const subId = thunkAPI.getState().subscription.subInfo.subID
            return await subscriptionService.cancelSub(token, subId)
        } catch (error) {
            const message = 
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
        
        return thunkAPI.rejectWithValue(message)
        }
    })


export const subscriptionSlice = createSlice({
    name:'subscription',
    initialState,
    reducers:{
        reset: (state) => initialState,
        
        clearMessage: (state) => {
            state.message = null
        }
    },
    extraReducers: (builder) =>{
        builder 
            .addCase(getSubscription.pending, (state)=>{
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(getSubscription.fulfilled, (state,action)=>{
                state.isLoading = false
                state.isSuccess = true
                state.subInfo = action.payload
            }) 
            .addCase(getSubscription.rejected, (state, action)=>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            
            .addCase(startBasicSub.pending, (state)=>{
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(startBasicSub.fulfilled, (state,action)=>{
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.subInfo = action.payload
            }) 
            .addCase(startBasicSub.rejected, (state, action)=>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            

            .addCase(startProSub.pending, (state)=>{
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(startProSub.fulfilled, (state,action)=>{
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.subInfo = action.payload
            }) 
            .addCase(startProSub.rejected, (state, action)=>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
           
     
            
            .addCase(cancelSub.pending, (state)=>{
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(cancelSub.fulfilled, (state,action)=>{
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.subInfo = {
                    //include the previous subscription info and include the cancel_at_period_end
                    ...state.subInfo,
                    
                    cancel_at_period_end: action.payload.cancel_at_period_end, // Whether it will cancel at the end of the period
                    
                };
                state.message = 'Subscription cancellation request processed successfully.';
            })
            .addCase(cancelSub.rejected, (state, action)=>{
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    },
            
            
})

export const  {reset} = subscriptionSlice.actions
export default subscriptionSlice.reducer